module.exports = __webpack_public_path__ + "img/bedroom.a418733c.svg";